import { render, staticRenderFns } from "./Arquivos.vue?vue&type=template&id=29bf8a1f&scoped=true&"
import script from "./Arquivos.vue?vue&type=script&lang=js&"
export * from "./Arquivos.vue?vue&type=script&lang=js&"
import style0 from "./Arquivos.vue?vue&type=style&index=0&id=29bf8a1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bf8a1f",
  null
  
)

export default component.exports